import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import authActions from '@/redux/auth/actions';
import { type AuthConnectionFlow } from '@/types/auth';

/**
 * Why this is needed is documented on the `clearConnectionErrors` action creator.
 *
 * `flow` is the surface doing the mounting; only its own banner flag is cleared.
 */
export function useClearConnectionErrorsOnMount(flow: AuthConnectionFlow) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(authActions.clearConnectionErrors(flow));
  }, [dispatch, flow]);
}
